import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  id?: string;
  align?: 'center' | 'left';
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  id,
  align = 'center',
  tone = 'light'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';
  const titleColor = tone === 'light' ? 'text-forest-800' : 'text-cream';
  const subtitleColor = tone === 'light' ? 'text-forest-900/70' : 'text-cream/75';
  const eyebrowColor = tone === 'light' ? 'text-lime-600' : 'text-gold-400';
  return <div className={`max-w-2xl ${alignment}`} data-id="element-181" data-mp="1u0xjsloxxdp">
      {eyebrow && <p className={`mb-3 text-[11px] font-extrabold uppercase tracking-[0.22em] ${eyebrowColor}`} data-id="element-182" data-mp="6t54ecl57j0v">
          {eyebrow}
        </p>}
      <h2 id={id} className={`font-display text-[30px] font-extrabold leading-tight tracking-tight sm:text-4xl ${titleColor}`} data-id="element-183" data-mp="uig03fnmyn85">
        {title}
      </h2>
      {subtitle && <p className={`mt-3 text-sm leading-relaxed sm:text-base ${subtitleColor}`} data-id="element-184" data-mp="1t9fsb8t5faka">{subtitle}</p>}
    </div>;
}